<template>
    <div>

        <button class="btn btn-outline-primary" type="button" v-b-modal="'export'">
            <span>{{ $t('lbl_EMPBE_ReportAll_Title_Button_ExportData') }}</span>
        </button>
        
        
        <DialogModal :id="'export'" @callBackConfirm="Export()" ref="ExportModal" :isConfirmDisabled="isConfirmDisabled" :ConfirmText="$t('lbl_EMPBE_ReportAll_component_Export_Export')" :CancelText="$t('lbl_EMPBE_ReportAll_component_Cancel')" >
            <div class="d-flex flex-column gap-8px">
                <!--Export all report(s) data-->
                <div class="Export-Select">
                    <div class="mb-4 Modal-MainTitle">
                        {{ $t('lbl_EMPBE_ReportAll_component_Export_ExportReportData') }}
                    </div>
                    <b-form-group>
                        <div class="radio radio-primary mb-2">
                            <b-form-radio v-model="ExportOptions.IsExportGridSelection" name="Edition" :value="false">
                                <span v-html="$t('lbl_EMPBE_ReportAll_component_Export_AllReportName',{name:EditionName})"></span>
                            </b-form-radio>
                        </div>
                        <div class="radio radio-primary">
                            <b-form-radio v-model="ExportOptions.IsExportGridSelection" name="Edition" :value="true"
                                :disabled="!IsGridSelected">
                                <span v-html="$t('lbl_EMPBE_ReportAll_component_Export_SelectedReport',{number:GetSelectedCount})"></span>
                                <!-- Selcted: {{ GetSelectedCount }} report(s) -->
                            </b-form-radio>
                        </div>
                    </b-form-group>
                </div>
                <!--Data layer-->
                <div v-if="isSuperAdmin" lass="Data-Layer">
                    <div class="mb-2 Modal-SubTitle">
                        {{ $t('lbl_EMPBE_ReportAll_component_DataLayer') }}
                    </div>
                    <b-form-group>
                        <div class="radio d-flex radio-primary mb-2">
                            <b-form-radio v-model="ExportOptions.DataLayer" id="SystemData" name="DataLayer"
                                value="SystemData" class="my-auto">
                            </b-form-radio>
                            <label name="All" class="LayeredLabel" for="SystemData" >
                                <div class="Main-Text"> {{ $t('lbl_EMPBE_ReportAll_component_SystemData') }}</div>
                                <div class="Sub-Text">{{ $t('lbl_EMPBE_ReportAll_component_SystemData_Text') }}</div>
                            </label>
                        </div>

                        <div class="radio d-flex radio-primary mb-2">
                            <b-form-radio v-model="ExportOptions.DataLayer" id="SupplierData" name="DataLayer"
                                value="SupplierData" class="my-auto">
                            </b-form-radio>
                            <label for="SupplierData" class="LayeredLabel">
                                <div class="Main-Text">{{ $t('lbl_EMPBE_ReportAll_component_SupplierData') }}</div>
                                <div class="Sub-Text">{{ $t('lbl_EMPBE_ReportAll_component_SupplierData_Text') }}</div>
                            </label>
                        </div>

                        <div class="radio d-flex radio-primary ">
                            <b-form-radio v-model="ExportOptions.DataLayer" id="UniversalData" name="DataLayer"
                                value="UniversalData" class="my-auto">
                            </b-form-radio>
                            <label for="UniversalData" class="LayeredLabel">
                                <div class="Main-Text">{{ $t('lbl_EMPBE_ReportAll_component_UniversalData') }}</div>
                                <div class="Sub-Text">{{ $t('lbl_EMPBE_ReportAll_component_UniversalData_Text') }}</div>
                            </label>
                        </div>
                    </b-form-group>
                </div>
                <!--Version-->
                <div v-if="isSuperAdmin" class="Version">
                    <div class="mb-2 Modal-SubTitle">
                        {{ $t('lbl_EMPBE_ReportAll_component_Export_Version') }}
                    </div>
                    <b-form-group>
                        <div class="radio radio-primary">
                            <b-form-radio v-model="ExportOptions.IsRaw" name="Version" :value="false" :disabled="!GetLastModified">
                                <div v-if="GetLastModified">{{ GetLastModified }}</div>
                                <div v-if="!GetLastModified">{{ $t('lbl_EMPBE_ReportAll_component_Export_NoRevisedVersions') }}</div>
                                
                            </b-form-radio>
                        </div>
                        <div class="radio radio-primary mb-2">
                            <b-form-radio v-model="ExportOptions.IsRaw" name="Version" :value="true">
                                {{ $t('lbl_EMPBE_ReportAll_component_Export_Original') }}
                            </b-form-radio>
                        </div>

                    </b-form-group>
                </div>
                <div>
                </div>
            </div>
        </DialogModal>

    </div>
</template>

<script>

import DialogModal from '../../../components/popup/dialogModal.vue'
import { reportService } from '@/_services/report.service';

export default {
    props: ["SelectedEdition", "EditionName","lastUpdate", "GridSelected","IsGridSelectedCrossPage","GridSearchQuery", "GetSelectedCount", "isSuperAdmin"],
    components: {
        DialogModal
    },
    data() {
        return {
            ExportOptions: {
                IsExportGridSelection : false,
                DataLayer: this.isSuperAdmin ? "SystemData" : "SupplierData",
                IsRaw: this.GetLastModified ? true : false,             
            }
        }
    },
    computed: {
        GetSelectedIds() {
            if(this.ExportOptions.IsExportGridSelection){
                return this.GridSelected.join(',')
            }
            return "";
        },
        isConfirmDisabled(){
            return !this.SelectedEdition || !this.ExportOptions.DataLayer
        },
        GetLastModified(){

            const latestDate = this.lastUpdate.find(x => (this.ExportOptions.DataLayer == "UniversalData") ? 
            x.type == this.ExportOptions.DataLayer : x.type != this.ExportOptions.DataLayer);

            if(!latestDate){
                return "";
            }
            
            return this.$t('lbl_EMPBE_ReportAll_component_Export_RevisedVersionsLast',{timers:latestDate.updateDate,username:latestDate.updateBy})
        },
        IsGridSelected(){
            const  IsGridSelected = this.GridSelected.length > 0 || this.IsGridSelectedCrossPage
            this.ExportOptions.IsExportGridSelection = IsGridSelected
            return IsGridSelected
        }

    },
    methods: {
        async Export() {
            this.ModalLoad(true)
            switch (this.ExportOptions.DataLayer) {
                case "SupplierData":
                    await this.GetSupplierSpecificReportData();
                    break;
                case "UniversalData":
                    await this.GetSupplierUniversalReportData();
                    break;
                case "SystemData":
                    await this.GetSupplierSystemData();
                default:
                    this.CloseModal();
            }
            this.CloseModal();
        },
        callBackCancel() {
        },
        async GetSupplierSpecificReportData() {

            const query = this.GetExportQuery("SupplierSpecific")
            
            await reportService.Report_SupplierReport_GetSupplierSpecificReportData(query).then(res => {
                console.log(res)
                if (res.isSuccessful) {
                    //Download
                    window.location.assign(res.data)
                }
                this.ModalLoad(false)
            })
        },
        async GetSupplierUniversalReportData() {
            const query = this.GetExportQuery("Universal")

            await reportService.Report_SupplierReport_GetUniversalData(query).then(res => {
                console.log(res)
                if (res.isSuccessful) {
                    //Download
                    window.location.assign(res.data)
                    
                }
                this.ModalLoad(false)
            })
        },
        async GetSupplierSystemData(){
            const query = this.GetExportQuery("SystemData")
            await reportService.Report_SupplierReport_GetSystemData(query).then(res => {
                console.log(res)
                if (res.isSuccessful) {
                    //Download
                    window.location.assign(res.data)
                }
                this.ModalLoad(false)
            })
        },
        CloseModal() {
            this.$refs.ExportModal.CloseModal();
        },
        GetExportFileName(ExportType) {
            var d = new Date
            var dformat = [
                d.getFullYear(),
                d.getMonth() + 1,
                d.getDate(),].join('-') + ' ' +
                [d.getHours(),
                d.getMinutes()].join(':');
            return `${ExportType}_${this.EditionName}_${dformat}`
        },
        ModalLoad(state){
            this.$refs.ExportModal.isLoading = state
        },
        GetExportQuery(ExportDataType){
            const query = {
                BatchId: this.SelectedEdition,
                DelimitedCompanyId: ExportDataType == "Universal" ? "" :this.GetSelectedIds,
                IsGetRawData: this.ExportOptions.IsRaw,
                fileName: this.GetExportFileName(ExportDataType),
                gridSearchParam : this.IsGridSelectedCrossPage ? this.GridSearchQuery : null
            }
            
            return query;
        }
    }
    // watch:{
    //     IsGridSelected(newVal){
    //         this.ExportOptions.IsExportGridSelection = newVal
    //     }
    // }
}
</script>
